export default __webpack_public_path__ + "static/media/logo-discovery-benefits.c095c7b5.png";